<div>
     <section id="main" class="bg-light">
          <div id="container" class="container">
               <div class="overlay" *ngIf="isLoading">
                    <h1 class="heading" [innerHtml]="'Loading' | translator:'base'">Loading...</h1>
                    <img />
               </div>
               <div class="overlay" *ngIf="isSaving">
                    <h1 class="heading" [innerHtml]="'SavingLoaderText' | translator: 'base'">Saving...</h1>
                    <img alt="Saving" />
               </div>
               <div class="d-flex justify-content-between align-items-center" id="page-title">
                    <h1 class="page-title" [title]="'psp_monitoring' | translator:'base'"
                         [innerHtml]="'psp_monitoring' | translator:'base'">
                         PSP Monitoring
                    </h1>
               </div>

               <span *ngIf="isLoading === false">
                    <div class="row">
                         <div class="col-12">
                              <p>
                                   <span [innerHtml]="'MonitoringInfo2' | translator: 'driver'">
                                        The optional PSP Monitoring service automatically monitors your PSP record and
                                        notifies you when changes occur. Drivers enrolled in this free service can
                                        receive email notifications and may also opt in to text message alerts.
                                   </span>
                              </p>
                         </div>
                    </div>

                    <div class="row">
                         <div class="col-12" *ngIf="isEnrolledInMonitoring() === false">
                              <p>
                                   <span [innerHtml]="'monitor_not_enrolled' | translator:'base'">
                                        You are not currently enrolled in PSP Monitoring. By enrolling, you will
                                        automatically receive email notifications whenever changes are made to your PSP
                                        record.
                                   </span>
                              </p>
                         </div>

                         <div class="col-12" *ngIf="isEnrolledInMonitoring() === true">
                              <p>
                                   <span [innerHtml]="'monitor_already_enrolled' | translator:'base'">
                                        You are currently enrolled in PSP Monitoring
                                   </span>
                                   <span *ngIf="isEnrolledInSms() === true"
                                        [innerHtml]="'monitor_email_and_sms' | translator:'base'">
                                        and will receive both email and text message notifications when your PSP record changes
                                   </span>.
                              </p>
                         </div>

                         <div class="col-12">
                              <p *ngIf="isEnrolledInMonitoring() === true">
                                   <span [innerHtml]="'EmailSent' | translator: 'driver'">Your current email is: </span>
                                   <span class="bold">{{ userEmail() }}</span>
                              </p>
                              <p *ngIf="isEnrolledInSms() === true">
                                   <span [innerHtml]="'monitor_driver_sms_set' | translator: 'driver'">
                                        Your current cell phone number is:
                                   </span>
                                   <span class="bold">{{ cellPhoneDisplay() }}</span>
                              </p>
                              <button *ngIf="isEnrolledInMonitoring() === false" class="btn btn-primary mb-3"
                                   [title]="'driver_ad' | translator: 'base'" name="startMonitoring"
                                   id="startMonitoring" (click)="startMonitoring()">
                                   <span [title]="'driver_monitor_start' | translator: 'base'"
                                        [innerHtml]="'driver_monitor_start' | translator: 'base'">Start
                                        Monitoring</span>
                              </button>
                         </div>

                         <div class="col-12" *ngIf="isEnrolledInMonitoring() === true">
                              <span *ngIf="isEnrolledInSms() === true">
                                   <button class="btn btn-outline-primary mb-3"
                                        [title]="'driver_remove_sms' | translator: 'base'" name="okay"
                                        (click)="removeSms()">
                                        <span [title]="'driver_remove_sms' | translator: 'audit'"
                                             [innerHtml]="'driver_remove_sms' | translator: 'base'">Remove SMS</span>
                                   </button>
                              </span>

                              <span *ngIf="isEnrolledInSms() === false && !addingSms">
                                   <p class="bold" [innerHtml]="'monitor_question' | translator:'base'"
                                        *ngIf="sendText === false">
                                        Select Add SMS to also receive text message notifications.
                                   </p>
                                   <button class="btn btn-primary mb-3" [title]="'driver_add_sms' | translator: 'base'"
                                        name="okay" (click)="showAddSms()">
                                        <span [title]="'driver_add_sms' | translator: 'base'"
                                             [innerHtml]="'driver_add_sms' | translator: 'base'">Add SMS</span>
                                   </button>
                              </span>
                              <h2 *ngIf="addingSms" [innerHtml]="'driver_add_sms' | translator: 'base'">
                                   Add SMS
                              </h2>
                         </div>

                    <span *ngIf="isLockedOut === true" class="help-block text-danger bold mb-3"
                         [innerHtml]="'monitor_driver_sms_too_many_tries' | translator: 'base'">
                         <div class="col-12 col-lg-10 align-self-end help-block text-danger">
                              Too many failed attempts. Please try again later.
                         </div>
                    </span>

                    <span *ngIf="isLockedOut === false && addingSms" [formGroup]="form">
                         <div class="col-12 col-md-6 mb-3">
                              <label for="driverAltPhone" class="form-label">
                                   <span [innerHtml]="'driver_cell_phone_label' | translator: 'base'">
                                        Cell Phone Number
                                   </span>
                                   <span class="text-danger text-center ms-1"
                                        [title]="'Required' | translator: 'base'">*</span>
                              </label>

                                   <input formControlName="cellPhoneNumber"
                                        [title]="'driver_cell_phone_label' | translator: 'base'" class="form-control"
                                        type="tel" id="cellPhoneNumber" name="cellPhoneNumber"
                                        placeholder="(___) ___-____" mask="(000) 000-0000" maxLength="14"
                                        [disabled]="waitingForCode" />
                                   <span *ngIf="cellPhoneNumber!.invalid && cellPhoneNumber!.dirty"
                                        class="help-block text-danger"
                                        [innerHtml]="'PhoneNumber_format' | translator: 'base'">
                                        Phone Number must be 10 digits.
                                   </span>
                                   <span *ngIf="form!.errors?.['cellRequired']" class="help-block text-danger"
                                        [innerHtml]="'driver_cell_phone_required' | translator: 'base'">
                                        <div class="col-12 col-lg-10 align-self-end help-block text-danger">
                                             Cell phone number is required.
                                        </div>
                                   </span>
                              </div>
                              <div class="d-flex flex-row gap-2 justify-content-start" role="group">
                                   <button *ngIf="waitingForCode === false" class="btn btn-primary mb-3 me-3 order-1"
                                        [title]="'verify_phone_number' | translator: 'base'" name="okay"
                                        (click)="verifyPhoneNumber()"
                                        [disabled]="form!.errors?.['cellRequired'] || cellPhoneNumber!.invalid">
                                        <span [title]="'verify_phone_number' | translator: 'base'"
                                             [innerHtml]="'verify_phone_number' | translator: 'base'">
                                             Verify Phone Number
                                        </span>
                                   </button>

                                   <button *ngIf="waitingForCode === false" class="btn btn-outline-primary mb-3 order-0"
                                        [title]="'Cancel' | translator: 'base'" id="cancelWithoutPhone"
                                        name="cancelWithoutPhone" name="okay" (click)="cancelAddSms()">
                                        <span [title]="'Cancel' | translator: 'base'"
                                             [innerHtml]="'Cancel' | translator: 'base'">
                                             Cancel
                                        </span>
                                   </button>
                              </div>
                              <span *ngIf="waitingForCode">
                                   <!-- <input waitingForCode> -->
                                   <div class="col-12 col-md-6 mb-3">
                                        <p>
                                             <span [innerHtml]="'driver_sms_code_explainer' | translator: 'base'">
                                                  You will receive a text with a verification code momentarily.
                                             </span>
                                             <span
                                                  [innerHtml]="'monitor_driver_max_tries_message' | translator: 'base'">
                                                  You are allowed three attempts to enter the correct code.
                                             </span>
                                        </p>

                                        <label for="validationCode" class="form-label mb-3">
                                             <span [innerHtml]="'driver_sms_verification_code' | translator: 'base'">
                                                  Enter verification code
                                             </span> <span class="text-danger text-center ms-1"
                                                  [title]="'Required' | translator: 'base'">*</span>
                                        </label>
                                        <input type="text" formControlName="validationCode"
                                             (keypress)="clearInvalidError()"
                                             [title]="'validationCode' | translator: 'base'" class="form-control"
                                             type="tel" id="validationCode" name="validationCode"
                                             [maxLength]="codeLength" />

                                        <span *ngIf="validationCode!.dirty && form!.errors?.['validationCodeRequired'] && !verificationCodeInvalid"
                                             class="help-block text-danger"
                                             [innerHtml]="'monitor_driver_validation_code_required' | translator: 'base'">
                                             <div class="col-12 col-lg-10 align-self-end help-block text-danger">
                                                  Verification code is required.
                                             </div>
                                        </span>

                                   <span *ngIf="verificationCodeInvalid && isLockedOut === false"
                                        class="help-block text-danger"
                                        [innerHtml]="'monitor_driver_code_invalid' | translator: 'base'">
                                        <div class="col-12 col-lg-10 align-self-end help-block text-danger">
                                             The code entered is incorrect. Please try again.
                                        </div>
                                   </span>
                              </div>

                              <button class="btn btn-primary mb-3 me-3" [title]="'verify' | translator: 'base'"
                                   name="okay" (click)="testVerificationCode()"
                                   [disabled]="form!.errors?.['validationCodeRequired']">
                                   <span [innerHtml]="'verify' | translator: 'base'">
                                        Verify
                                   </span>
                              </button>
                              <button class="btn btn-outline-primary mb-3 me-3" [title]="'Cancel' | translator: 'base'"
                                   name="okay" (click)="cancelAddSms()">
                                   <span [title]="'Cancel' | translator: 'base'"
                                        [innerHtml]="'Cancel' | translator: 'base'" id="cancelWithPhone"
                                        id="cancelWithPhone">
                                        Cancel
                                   </span>
                              </button>
                              <button class="btn btn-primary mb-3 me-3"
                                   [title]="'monitor_driver_send_new_code' | translator: 'base'" name="okay"
                                   (click)="verifyPhoneNumber()"
                                   [disabled]="form!.errors?.['cellRequired'] || cellPhoneNumber!.invalid || codesSentCount >= maxTryCount">
                                   <span [title]="'monitor_driver_new_code' | translator: 'base'"
                                        [innerHtml]="'monitor_driver_new_code' | translator: 'base'"
                                        >
                                        Send New Code
                                   </span>
                              </button>
                         </span>
                    </span>

                         <hr>

                         <p class="italic" [innerHtml]="'monitor_sms_disclaimer' | translator:'base'">
                              By opting in to receive PSP Record Monitoring text alerts, you agree to receive SMS
                              notifications from the Pre-Employment Screening Program regarding changes to your PSP
                              record. Consent is not required as a condition of purchase. Message frequency varies.
                              Message and data rates may apply. Reply STOP to unsubscribe or HELP for assistance.
                         </p>

                         <p *ngIf="isEnrolledInMonitoring() === true" id="removeDriverMonitorying"
                              name="removeDriverMonitorying">
                              <button class="btn btn-link" [title]="'monitor_opt_out' | translator: 'driver'"
                                   [innerHtml]="'monitor_opt_out' | translator: 'driver'"
                                   (click)="showOptOutInMonitoringModal()">
                                   Opt-Out of PSP Monitoring
                              </button>
                         </p>
                    </div>
                    <ng-template #OptOutInMonitoringModal let-modal>
                         <div class="modal-header">
                              <h3 id="monitor_opt_out_confirm_title" class="modal-title"
                                   [innerHtml]="'Opt-out-header' | translator: 'driver'">
                                   Opt-out of PSP Monitoring
                              </h3>
                         </div>
                         <div class="modal-body">
                              <p [innerHtml]="'monitor_opt_out_confirm_body' | translator: 'driver'">
                                   Click OK to confirm that you want to opt out of PSP Monitoring.
                              </p>
                         </div>
                         <div class="modal-footer">
                              <div class="d-flex flex-row-reverse text-nowrap">
                                   <button class="btn btn-primary" [title]="'OK' | translator: 'base'"
                                        [innerHtml]="'OK' | translator: 'base'" name="optOutMonitoringYes"
                                        id="optOutMonitoringYes" (click)="applyOptOutOfMonitoring()">
                                        OK
                                   </button>
                                   <button class="btn btn-outline-primary me-2" [title]="'Cancel' | translator: 'base'"
                                        [innerHtml]="'Cancel' | translator: 'base'" name="optOutMonitoringNo"
                                        id="optOutMonitoringNo" (click)="closeModal()">
                                        Cancel
                                   </button>
                              </div>
                         </div>
                    </ng-template>
               </span>
          </div>
          <ng-template #ErrorSavingModal let-modal>
               <div class="modal-header">
                    <h3 id="errorSavingModalTitle" class="modal-title" [innerHtml]="'Problem' | translator: 'driver'">
                         A problem has occurred
                    </h3>
               </div>
               <div class="modal-body">
                    <p [innerHtml]="'WasError' | translator: 'driver'">
                         Please contact the PSP Customer Support Team at
                         <a alt="call customer service" href="tel:8776429499" name="1-877-642-9499">1-877-642-9499</a>.
                         The PSP team is available by phone Monday through Thursday from 8 AM to 6
                         PM ET, and on Friday from 8 AM to 5 PM ET.
                    </p>
               </div>
               <div class="modal-footer">
                    <button class="btn btn-outline-primary" [title]="'OK' | translator: 'base'"
                         [innerHtml]="'OK' | translator: 'base'" name="okay" (click)="closeModal()">
                         OK
                    </button>
               </div>
          </ng-template>
     </section>
</div>